<template>
    <div>Plans Management</div>
</template>

<script>
export default {
};
</script>